"use client"
import { createContext, useContext } from "react"
import { PERSONAS, type Persona } from "./utils"

export const PersonaContext = createContext<{
  persona: Persona
  setPersona: (value: Persona) => void
  togglePersona: () => void
}>({
  persona: PERSONAS.collector,
  setPersona: () => null,
  togglePersona: () => null,
})

export const usePersona = () => {
  return useContext(PersonaContext)
}
